import React from 'react';
import {ListItem, Footer, List, FooterLink} from '@deere/ux.uxframe-react';

function CUTFooter() {
    return (
        <Footer>
            <List className="nav">
                <ListItem>
                    <FooterLink href="https://www.deere.com/en/equipment/" target="_new"> Site Map</FooterLink>
                </ListItem>
                <ListItem>
                    <FooterLink href="https://www.deere.com/en/our-company/contact-us/">
                        Contact Us
                    </FooterLink>
                </ListItem>
                <ListItem>
                    <FooterLink
                        href="https://www.deere.com/en/privacy-and-data/"
                        target="_blank"
                        target="_new"
                        rel="noopener noreferrer"
                    >
                        Privacy and Data
                    </FooterLink>
                </ListItem>

                <ListItem>
                    <FooterLink
                        href="https://www.deere.com/en/privacy-and-data/cookie-statement/"
                        target="_new"

                    >
                        Cookie Settings
                    </FooterLink>
                </ListItem>
                <ListItem>
                    <FooterLink
                        href="https://www.deere.com/en/privacy-and-data/terms/"
                        target="_new"

                    >
                        Legal
                    </FooterLink>
                </ListItem>
            </List>
        </Footer>
    );
}

export default CUTFooter;
